import CitySEOHead from "@/components/feature/CitySEOHead";
import NMHeroSection from "./components/HeroSection";
import NMCitiesDirectory from "./components/CitiesDirectory";
import NMStateResources from "./components/StateResources";
import NMFAQSection, { faqs } from "./components/FAQSection";
import NMFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const services = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

const mappedFaqs = faqs.map((f) => ({ q: f.question, a: f.answer }));

export default function NewMexicoPage() {
  return (
    <>
      <CitySEOHead
        city="New Mexico"
        state="New Mexico"
        stateAbbr="NM"
        route="/states/new-mexico"
        title="New Mexico Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across New Mexico — Albuquerque, Santa Fe, Las Cruces, Rio Rancho, Roswell, and Farmington. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="New Mexico, United States"
        geoPosition="34.5199;-105.8701"
        faqs={mappedFaqs}
        servicesSchema={services}
      />
      <div className="font-sans">
        <NMHeroSection />
        <NMCitiesDirectory />
        <NMStateResources />
        <NMFAQSection />
        <SEOCrossLinks state="NM" />
        <NMFinalCTA />
      </div>
    </>
  );
}